import { DateRange } from '@sandbox-platform/shared-ui';

import {
  CommissionPaymentListFilters,
  CommissionPaymentMethod,
  CommissionPaymentType,
} from '../../../../types/commission-payment.types';

export interface CommissionPaymentSearchParams {
  page: number;
  limit: number;
  paymentType?: CommissionPaymentType;
  paymentMethod?: CommissionPaymentMethod;
  payeeOrganizationId?: string;
  invoiceRecipientOrganizationId?: string;
  dateFrom?: string;
  dateTo?: string;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
}

export function encodePaymentSearchParams(
  currentPage: number,
  pageSize: number,
  dateRange: DateRange,
  filters: CommissionPaymentListFilters,
  sortBy: string,
  sortDirection: 'asc' | 'desc'
): CommissionPaymentSearchParams {
  const params: CommissionPaymentSearchParams = {
    page: currentPage,
    limit: pageSize,
    sortBy,
    sortDirection,
  };

  if (dateRange?.from) {
    params.dateFrom =
      dateRange.from instanceof Date
        ? dateRange.from.toISOString()
        : dateRange.from;
  }

  if (dateRange?.to) {
    params.dateTo =
      dateRange.to instanceof Date ? dateRange.to.toISOString() : dateRange.to;
  }

  if (filters.paymentType !== 'all') {
    params.paymentType = filters.paymentType;
  }

  if (filters.paymentMethod !== 'all') {
    params.paymentMethod = filters.paymentMethod;
  }

  if (filters.payeeOrganization?.id) {
    params.payeeOrganizationId = filters.payeeOrganization.id;
  }

  if (filters.payerOrganization?.id) {
    params.invoiceRecipientOrganizationId = filters.payerOrganization.id;
  }

  return params;
}
